<template>
	<div class="aboutus">
		<HNB></HNB>
		<div class="nav" v-show="navstyle">
			<div class="navshell" style="width: 85%;margin: 0 auto;">
				<div class="nav-list" v-for="(item,i) in aboutpart" @click="choosenav(item.apactive)">
					<span :class="{'active':navindex==item.apactive}">{{item.write}}</span>
				</div>
			</div>
		</div>
		<div class="title">关于我们</div>
		<div class="aboutusbg"><img :src="aboutbgimg"></div>
		<div class="choosenav">
			<div class="choosenav-list" v-for="(item,i) in aboutpart" @click="choosenav(item.apactive)">
				<span :class="{'active':navindex==item.apactive}">{{item.write}}</span>
				<div class="line" v-if="i<(aboutpart.length-1)">|</div>
			</div>
		</div>
		
		<!--  -->
		<div class="box1" style="display: none;" v-show="this.navindex=='gotolf'">
			<div class="box1-up" :style="box1img">
				<div class="lfconcept">{{lfconcept}}</div>
				<div class="lfinfo">{{lfinfo}}</div>
			</div>
			<div class="box1-dowm" :style="box1dowmimg">
				<div class="lfconcept">{{lfname}}</div>
				<div class="lfconcept1">{{lfwrite}}</div>
				<div class="lfinfo" v-html="dowminfo">{{dowminfo}}</div>
			</div>
		</div>

		<!-- 乐范历程 -->
		<div class="box2" style="display: none;" v-show="this.navindex=='lfcourse'">
			<div class="box2-up" :style="box2bg">发展历史</div>
			<!-- <div class="line"></div> -->
			<div ref="course" v-for="(item ,index) in courseAry">
				<courseView :courseimg="item.course_img" :time="getCourseDate(item.course_date)"
					:title="item.course_name" :write="item.course_img_desc" :bright="index == brightIndex ">
				</courseView>
			</div>

		</div>

		<div class="box4" v-show="this.navindex=='honor'">
			<!-- 			<div class="box4-Patent" v-for="PatentItem in honorPatent">
				<PatentView :name="PatentItem.name" :introduceAry="PatentItem.introduceAry"></PatentView>
			</div> -->

			<div class="box4-prize" v-for="items in prizesAry">
				<div class="box4-prize-name">{{items.name}}</div>
				<div class="box4-prize-view">
					<div class="box4-prize-view-box" v-for="item in items.Ary">
						<prizeView :Img="item.honor_img" :name="item.honor_name" :bac="prizeBgc(item.honor_type)">
						</prizeView>
					</div>
				</div>
				<div class="box4-prize-line"></div>
			</div>

		</div>

		<div v-show="this.navindex=='info'">
			<div class="box3" v-for="(item,i) in info">
				<div class="img"><img :src="item.news_img" style="width: 100%;"></div>
				<div style="display: flex; width: 85%;margin: 0 auto;">
					<div class="news">新闻</div>
					<div class="time">{{item.upload_time}}</div>
				</div>
				<div class="title">{{item.news_title}}</div>
				<div class="write" @click="openUrl(item.openurl)">{{item.desc}}</div>
			</div>
			<div style="width: 100%;height:6.25rem;"></div>
		</div>
		<bottom style="margin-top: 80px;" :BsTitle="bsTitle"></bottom>
	</div>
</template>

<script>
	import HNB from '../components/HeaderNavigationBar.vue'
	import bottom from '../components/Bottom.vue'
	import PatentView from '../components/patentView.vue'
	import prizeView from '../components/prizeView.vue'
	import courseView from '../components/courseView.vue'
	import request from '../common/request.js'

	export default {
		name: 'aboutus',
		data() {
			return {
				bsTitle: ['首页', '关于我们'],
				brightIndex: 0,
				lfname: '乐范创始人 ',
				lfwrite: '戴冬英',
				dowminfo: '戴冬英,英文名Helen,厦门创新协会成员,吴晓波频道新匠人学院福建分会共治会副会长,在大健康产业供应链管理及制造资源领域深耕超过十年,2017年创办乐范,正式进军移动健康领域</br> 2003年10月-2012年6月——在蒙发利（现奥佳华集团） 负责组建电子厂、箱包厂,PMC团队,在采购、工艺、生产制造等供应链管理方面积累了多年经验<br> 2012年6月－2016年12月—— 成立全新事业部, 组建团队运营美国品牌Jam蓝牙音箱,成功打通国内销售通路,取得不小的成绩,四年的沉淀不但在销售渠道方面积累了势能,还培养出一批能打能抗的运营团队。</br>2017年2月——觉得时机已经成熟的戴冬英正式进军移动健康领域,带领团队打造首款爆品魔力贴,这款号称“口袋里的按摩师” 的按摩贴,可以说是国内首款大规模销售的低频类按摩产品,出货量已超过100万。</br>2018年——已经推出多款爆品的乐范凭借实力被更多人看见,戴冬英也进入了吴晓波频道举办的2018年度新匠人100榜单,成为极具潜力新国货代表的品牌掌门人',
				box1img: 'background-image: url(' + this.GLOBAL.imgHost + '/images/aboutus/gotolfbg.png);',
				box1dowmimg: 'background-image: url(' + this.GLOBAL.imgHost + '/images/aboutus/ceobg.png);',
				box2bg: 'background-image: url(' + this.GLOBAL.imgHost + '/images/aboutus/mapbg.png);',
				centerimg: this.GLOBAL.imgHost + '/images/aboutus/people.png',
				navstyle: false,
				lfconcept: '乐范理念',
				lfinfo: '乐范健康科技有限公司是移动健康领域一家新晋的品牌。以“让按摩变得简单”为公司理念，致力于以高性价比的追求，为广大消费者打造优质的便携移动按摩产品。在社会快速发展，生活压力和工作压力都成倍增长的时代背景下，让年轻人正承受着远高于父辈的压力，难以协调工作与私人时间的矛盾，无法让疲惫的身体得到放松，成为当下年轻人亚健康状态的主要原因之一。乐范敏锐的察觉到这一点，将按摩产品年轻化，碎片化，私属化，告别传统按摩器具的笨重，重新定义移动健康。让忙于工作的年轻人也能体会到按摩放松的舒适与乐趣。',
				navindex: 'gotolf',
				aboutbgimg: this.GLOBAL.imgHost + '/images/aboutus/aboutusbg.png',
				courseAry: [],
				aboutpart: [{
						write: '走进乐范',
						apactive: 'gotolf'
					},
					{
						write: '乐范历程',
						apactive: 'lfcourse'
					},
					{
						write: '奖项荣誉',
						apactive: 'honor',
					},
					{
						write: '信息资讯',
						apactive: 'info'
					},


				],
				honorPatent: [],
				info: [],
				// info: [{
				// 		imgurl: this.GLOBAL.imgHost + '/images/aboutus/info_1.jpg',
				// 		news: '新闻',
				// 		time: '2020-04-02',
				// 		title: '乐范联合厦航，助力安心复工',
				// 		write: '此次乐范与厦航的合作，不仅仅是赠送口罩这么简单，领取完口罩后，点击“随便逛逛”，里面还有乐范为大家准备的厦航专属福利......',
				// 		url: 'http://news.jxntv.cn/2020/0402/9366121.shtml',
				// 	},
				// 	{
				// 		imgurl: this.GLOBAL.imgHost + '/images/aboutus/info_2.jpg',
				// 		news: '新闻',
				// 		time: '2020-03-25',
				// 		title: '乐范健康科技销售额逆势增长236%',
				// 		write: '没人会想到,2020年的春节让人如此焦虑,快速发展中国经济竟然被新冠肺炎疫情踩了一脚刹车。随着“封城”“交通管制”......',
				// 		url: 'https://tech.china.com/article/20200325/20200325486377.html',
				// 	},
				// 	{
				// 		imgurl: this.GLOBAL.imgHost + '/images/aboutus/info_3.jpg',
				// 		news: '新闻',
				// 		time: '2020-02-18',
				// 		title: '小米眼仪测评：充电2小时按摩100分钟',
				// 		write: '小米被誉为“国货之光”，有多牛就不必多说了，从创办到上市，再到国货之光，到现在已经十年了，期间我们也看到了许多小米......',
				// 		url: 'https://www.toutiao.com/a6794635368181268995/',
				// 	},
				// 	{
				// 		imgurl: this.GLOBAL.imgHost + '/images/aboutus/info_4.jpg',
				// 		news: '新闻',
				// 		time: '2019-08-15',
				// 		title: '乐范双色颈枕让你的颈椎不再无处安放',
				// 		write: '经常出差或者旅行的小伙伴都知道无论是在飞机、火车还是汽车上，时间久了我们都会出现一个"无处安放"的"大脑袋"......',
				// 		url: 'https://www.sohu.com/a/333936067_100210898',
				// 	},
				// 	{
				// 		imgurl: this.GLOBAL.imgHost + '/images/aboutus/info_5.jpg',
				// 		news: '新闻',
				// 		time: '2018-08-16',
				// 		title: '乐范脚部揉捏按摩器常伴左右',
				// 		write: '众所周知，人体脚底有诸多穴位，当穴位被打通后，可以改善血液循环，加快人体新陈代谢。不仅如此，经常进行足底按摩......',
				// 		url: 'https://zhuanlan.zhihu.com/p/42130491',
				// 	}
				// ],
				prizesAry: [],
			}
		},
		async mounted() {
			window.addEventListener('scroll', this.getScroll);
			//初次加载  回到顶部
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			if (scrollTop > 0) {
				document.documentElement.scrollTop = 0;
			}
			await this.getCourseList()
			// this.getPatentList()
			await this.getHonorList()
			await this.getNewsList()
		},
		destroyed() {
			window.removeEventListener('scroll', this.getScroll);
		},
		methods: {
			// 获取历程列表
			async getCourseList() {
				// request.uniRequest('/course/getCourseList')
				// 	.then(res => {
				// 		this.courseAry = res.data
				// 		console.log('test-------', this.courseAry);
				// 	}).catch(e => {})
				let res = await this.$Cloud.table(`lf_func_lefan_course`).get({
					page: 0,
					pageSize: 1000,
					sort_by: 'create_at',
					order_by: 'asc'
				})
				
				console.log('获取历程列表===>>>>',res)

				const {
					code,
					data
				} = res
				if (code == 200) {
					this.courseAry = data.filter(item => item.is_check == 2)

				}
			},
			getPatentList() {
				// 获取专利列表
				// request.uniRequest('/patent/getPatentList')
				// 	.then(res => {
				// 		const inventPatentArr = res.data.filter(item => item.patent_type == 0)
				// 		const newPatentArr = res.data.filter(item => item.patent_type == 1)
				// 		const designPatentArr = res.data.filter(item => item.patent_type == 2)

				// 		this.honorPatent = [{
				// 				name: '发明专利',
				// 				introduceAry: inventPatentArr
				// 			},
				// 			{
				// 				name: '实用新型专利',
				// 				introduceAry: newPatentArr
				// 			},
				// 			{
				// 				name: '外观设计专利',
				// 				introduceAry: designPatentArr
				// 			}
				// 		]

				// 	}).catch(e => {})
				
				

			},
			// 获取荣誉奖项列表
			async getHonorList() {
				let res = await this.$Cloud.table(`lf_func_lefan_honor`).get({
					page: 0,
					pageSize: 1000
				})
				console.log('获取奖项荣誉列表', res)

				const {
					code,
					data
				} = res

				if (code == 200) {
					const grandAry = res.data.filter(item => item.is_check == 2 && item.honor_type == 0)
					const prizeAry = res.data.filter(item => item.is_check == 2 && item.honor_type == 1)
					const mechanismAry = res.data.filter(item => item.is_check == 2 && item.honor_type == 2)
					this.prizesAry = [{
							name: '国际大奖',
							Ary: grandAry
						},
						{
							name: '国家级认证及奖项',
							Ary: prizeAry
						},
						{
							name: '权威鉴定机构',
							Ary: mechanismAry
						}
					]

				}
			},
			async getNewsList() {
				// 获取新闻列表
				// request.uniRequest('/news/getNewsList')
				// 	.then(res => {
				// 		// this.posters = res.data.filter(item => item.web_type == 0)
				// 		this.info = res.data

				// 		console.log('test------news', this.info);
				// 	}).catch(e => {})
				
				let res = await this.$Cloud.table(`lf_func_lefan_news`).get({ page: 0, pageSize: 1000 })
				
				console.log('获取新闻列表',res)
				
				const {code,data} = res
				if(code == 200) {
					this.info = data.filter(item=>item.is_check==2)
				}
			},
			choosenav(e) {
				let that = this
				that.navindex = e
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body
					.scrollTop;
				if (scrollTop > 450) {
					document.documentElement.scrollTop = 450;
				}
			},
			getScroll() {
				let that = this;
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body
					.scrollTop;
				let pageWidth = document.documentElement.clientWidth;
				if (scrollTop > 450) {
					that.navstyle = true
				} else {
					that.navstyle = false
				}

				// let ref = this.$refs.course[0];

				// if (scrollTop < ref.offsetTop) {
				// 	that.brightIndex = 0;
				// } else {
				// 	that.brightIndex = Math.ceil((scrollTop - ref.offsetTop) / ref.offsetHeight);
				// }
			},
			openUrl(url) {
				window.location.href = url;
			}
		},
		computed: {
			// 历程时间格式化
			getCourseDate() {
				return function(date) {
					const dateArr = date.split('-')
					return dateArr[0] + '年' + Number.parseInt(dateArr[1]) + '月'
				}
			},
			prizeBgc() {
				return function(prizename) {
					if (prizename == 2) {
						return "#FFFFFF"
					}
					return "#F4F4F4"
				}
			}



		},
		components: {
			HNB,
			bottom,
			PatentView,
			prizeView,
			courseView
		}
	}
</script>

<style>
	.nav {
		width: 100%;
		height: 3.5rem;
		max-width: 33.75rem;
		line-height: 3.5rem;
		display: flex;
		text-align: center;
		justify-content: space-around;
		position: fixed;
		top: 0rem;
		background-color: white;
		z-index: 333;
	}

	.navshell {
		display: flex;
		text-align: center;
		justify-content: space-around;
	}

	.nav .nav-list {
		/* width: 3rem; */
		/* height: 3rem; */
		/* border-bottom: 1px solid red; */
	}

	.nav .nav-list span {
		font-size: 0.75rem;
		font-family: Alibaba-PuHuiTi-M;
		font-weight: 500;
		color: rgba(24, 24, 24, 1);
		opacity: 0.7;
	}

	.nav .nav-list span.active {
		border-bottom: #00C785 2px solid;
		opacity: 1;
	}

	.aboutus {
		max-width: 33.75rem;
		margin: 0 auto;
	}

	.aboutus .title {
		width: 100%;
		height: 5.75rem;
		font-size: 2rem;
		font-family: Alibaba-PuHuiTi-R;
		font-weight: 400;
		color: rgba(29, 29, 29, 1);
		line-height: 5.75rem;
	}

	.aboutusbg {
		width: 85%;
		margin: 0 auto;
		padding-top: 1.875rem;
		padding-bottom: 3.75rem;

	}

	.aboutusbg img {
		width: 100%;
		height: 100%;
	}

	.choosenav {
		width: 85%;
		margin: 0 auto;
		display: flex;
		justify-content: space-around;
		flex-wrap: wrap;
		flex-direction: row;
		align-items: center;

	}

	.choosenav .line {
		height: 1rem;
		font-weight: 100;
		color: #C2C2C2;
		/* margin-left: 1rem; */

	}

	.choosenav .choosenav-list {
		display: flex;
		justify-content: space-around;
		width: 25%;
	}

	.choosenav .choosenav-list span {
		font-size: 0.85rem !important;
		font-family: Alibaba-PuHuiTi-M;
		font-weight: 550;
		color: rgba(24, 24, 24, 1);
		opacity: 0.7 !important;
		padding-bottom: 0.8rem;
	}

	.choosenav .choosenav-list span.active {
		border-bottom: #00C785 2px solid;
		opacity: 1 !important;
	}

	.box1 {}

	.box1 .box1-up {
		width: 90%;
		height: 400px;
		margin: 0 auto;
		background-color: #00C785;
		background-size: 100% 100%;
		padding-bottom: 1.875rem;
		margin-top: 15%;
	}

	.box1 .lfconcept {
		width: 85%;
		margin: 0 auto;
		text-align: left;
		font-size: 1.2rem;
		font-family: Alibaba-PuHuiTi-M;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
		line-height: 5.0625rem;
		padding-top: 1.5rem;
	}

	.box1 .lfconcept1 {
		width: 85%;
		margin: 0 auto;
		text-align: left;
		font-size: 1.2rem;
		font-family: Alibaba-PuHuiTi-R;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
		padding-bottom: 10%;
		/* line-height:5.0625rem; */

	}

	.box1 .lfinfo {
		width: 88%;
		margin: 0 auto;
		text-align: left;
		font-size: 0.8rem;
		font-family: Alibaba-PuHuiTi-R;
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		line-height: 1.5rem;
		z-index: 2;
	}

	.box1 .box1-dowm {
		width: 90%;
		margin: 0 auto;
		background-size: 100%;
		margin-top: 15%;
		margin-bottom: 15%;
		padding-bottom: 20%;
	}

	.box2 {
		padding-bottom: 7rem;
	}



	.box2 .box2-up {
		width: 100%;
		height: 8rem;
		text-align: center;
		font-size: 1.2rem;
		font-family: Alibaba-PuHuiTi-M;
		font-weight: 550;
		background-size: 100% 100%;
		padding-top: 1.25rem;
		line-height: 5rem;
		margin-bottom: 80px;
	}



	.box3 {
		padding-top: 60px;

	}

	.box3 .img {
		width: 85%;
		margin: 0 auto -1px;
		background-color: rgba(255, 255, 255, 1);
	}

	.box3 .img img {
		width: 100%;
		height: 100%;
	}


	.box3 .news {
		background: rgba(0, 199, 133, 1);
		font-size: 0.8rem;
		font-family: Alibaba-PuHuiTi-R;
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
	}

	.box3 .time {
		font-size: 0.8rem;
		font-family: Alibaba-PuHuiTi-R;
		font-weight: 400;
		color: rgba(164, 164, 164, 1);
	}

	.box3 .title {
		width: 85%;
		height: 10%;
		margin: 0 auto;
		font-size: 1rem;
		font-family: Alibaba-PuHuiTi-M;
		font-weight: 550;
		color: rgba(24, 24, 24, 1);
		text-align: left;
		line-height: 45px;
	}

	.box3 .write {
		width: 85%;
		text-align: left;
		margin: 0 auto;
		font-size: 0.8rem;
		font-family: Alibaba-PuHuiTi-R;
		font-weight: 400;
		color: rgba(24, 24, 24, 1);
		opacity: 0.9;
		line-height: 1.5rem;
	}

	.box4 {}

	.box4 .box4-Patent {
		width: 100%;
	}

	.box4 .box4-prize {
		display: flex;
		flex-direction: column;

	}

	.box4 .box4-prize .box4-prize-name {
		/* margin-top: 4.875rem; */
		margin-top: 2.875rem;
		text-align: left;
		margin-left: 10%;
		font-weight: 500;
		font-size: 0.95rem;
		color: rgba(24, 24, 24, 1);
	}

	.box4 .box4-prize .box4-prize-view {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: flex-start;

	}

	.box4 .box4-prize .box4-prize-view .box4-prize-view-box {
		width: 40%;
		margin-top: 2.625rem;
		margin-left: 7%;
	}

	.box4 .box4-prize .box4-prize-line {
		height: 1px;
		width: 95%;
		background: rgba(229, 229, 229, 1);
		margin-top: 4.875rem;
		margin-left: 5%;
	}
</style>
